@if (field.showSimple) {
    <!-- sec-panel: the inset the sec-head banner bleeds into when this lands in a field-set cell
         rather than a .sec tile - see shared/styles/_section-header.scss. -->
    <div class="simple-requests sec-panel">
        <h3 class="sec-head">
            <button type="button" class="filter"
                    [class.active]="filter === 'all'"
                    [class.primary-font-color]="filter === 'all'"
                    (click)="toggle('all')">{{ field.label }}</button>
            @if (total) { <span class="count">({{ total }})</span> }
            @if (openCount) { <span class="sep">–</span> }
            @if (openCount) {
                <button type="button" class="filter"
                        [class.active]="filter === 'open'"
                        [class.primary-font-color]="filter === 'open'"
                        (click)="toggle('open')" i18n>Open ({{ openCount }})</button>
            }
            <app-section-action-button i18n-label label="Expand" icon="zoom_out_map"
                i18n-tip tip="Open the full list in a larger window"
                (act)="openBigList()"></app-section-action-button>
        </h3>

        <div class="rows-scroll">
            <table class="rows">
                @for (r of visible; track r.id) {
                    <tr [class.done]="r.srStatus === 'accepted'">
                        <td class="ref">
                            <a class="req-link" [routerLink]="url(r)">{{ r.refNr }}</a>
                        </td>
                        <td class="rtitle">
                            <div class="title-line">
                                <span>{{ r.title }}</span>
                                <span class="leader"></span>
                            </div>
                        </td>
                        <td class="icon">
                            <app-form-pill on="grid" [field]="field.channelPillField" [item]="r"></app-form-pill>
                        </td>
                        <td class="icon">
                            <app-form-pill on="grid" [field]="field.statusPillField" [item]="r"
                                (clicked)="onStatusClick(r)"></app-form-pill>
                        </td>
                        <td class="icon">
                            <app-form-pill on="grid" [field]="field.actionPillField" [item]="r"
                                (clicked)="onActionStatusClick(r)"></app-form-pill>
                        </td>
                        @if (canUnlink) {
                            <td class="icon">
                                <button type="button" class="unlink" data-field-name="unlinkRequest"
                                        matTooltip="Click to unlink this work order" i18n-matTooltip
                                        (click)="unlink(r)">
                                    <mat-icon>link_off</mat-icon>
                                </button>
                            </td>
                        }
                    </tr>
                } @empty {
                    <tr><td colspan="6" class="empty" i18n>No requests</td></tr>
                }
            </table>
        </div>

        @if (field.allowSimpleAdd && !field.readonly) {
            <div class="simple-add">
                @if (canLink) {
                <button type="button" class="link-add primary-font-color" data-grid-new="linkRequest"
                        matTooltip="Add a link to an existing request" i18n-matTooltip
                        (click)="link()">
                    <mat-icon>add_link</mat-icon><span>{{ field.linkLabel }}</span>
                </button>
                }
                @if (canAddChild) {
                <button type="button" class="link-add primary-font-color" data-grid-new="childRequest"
                        [matTooltip]="addCaseTip"
                        (click)="addCase()">
                    <mat-icon>live_help</mat-icon><span i18n>Add Case</span>
                </button>
                <button type="button" class="link-add primary-font-color" data-grid-new="workOrder"
                        [matTooltip]="addWorkOrderTip"
                        (click)="addWorkOrder()">
                    <mat-icon>construction</mat-icon><span i18n>Add Work Order</span>
                </button>
                }
            </div>
        }
    </div>
} @else {
    <app-grid [control]="control" [on]="on"></app-grid>
}
